import {
  Box,
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Wrap,
} from "@chakra-ui/react";
import { ApiErrorProvider } from "@raiden/library/components/ReactHookForm/ApiError";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Href } from "../../../components/Href";
import { Splash } from "../../../components/Splash";
import { CreateHandlerBookings } from "./Handler";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/RentalArea").RentalArea} rentalArea
 * @property {string} [date]
 * @property {boolean} isOpen
 * @property {() => void} onClose
 * @property {boolean} [isInModal]
 */
/**
 * @param {Props} props
 */
export function CreateBookings({
  rentalArea,
  date,
  isInModal = false,
  isOpen,
  onClose,
}) {
  const intl = useIntl();

  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccess = useCallback(() => {
    setIsSuccess(true);
  }, []);

  const handleResetForm = useCallback(() => {
    setIsSuccess(false);
    onClose();
  }, [onClose]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="5xl"
        scrollBehavior="inside"
        closeOnOverlayClick={false}
        blockScrollOnMount={!isInModal}
        isCentered>
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton onClick={handleResetForm} />

          <ModalHeader>
            <Text variant="h2" fontWeight={500}>
              <FormattedMessage defaultMessage="Demande de réservation" />
            </Text>
          </ModalHeader>

          {isSuccess ? (
            <Box pb="2rem">
              <Splash
                title={intl.formatMessage({
                  defaultMessage:
                    "Votre demande de réservation vous sera confirmée par mail",
                })}
                description={intl.formatMessage({
                  defaultMessage:
                    "Nous vous remercions pour votre confiance et vous répondrons au plus vite.",
                })}
                src={generateFrontPath({
                  id: "@front.internal-assets",
                  parameters: { filePath: "illustrations/contact-success.svg" },
                  includeBasePath: true,
                })}
                addon={
                  <Wrap justify="center" spacing="16px">
                    <Href
                      href={generateFrontPath({
                        id: "@front.communityHalls",
                      })}>
                      <Button
                        onClick={handleResetForm}
                        colorScheme="brandPrimary"
                        backgroundColor="brandPrimary.700">
                        <Text variant="button" color="inherit">
                          <FormattedMessage defaultMessage="Fermer" />
                        </Text>
                      </Button>
                    </Href>
                  </Wrap>
                }
              />
            </Box>
          ) : (
            <ApiErrorProvider>
              <CreateHandlerBookings
                rentalArea={rentalArea}
                date={date}
                onClose={onClose}
                onSuccess={handleSuccess}
              />
            </ApiErrorProvider>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
